
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Campaign } from "@/types/campaigns";
import { Campaign as LegacyCampaign } from "./CampaignModal";
import CampaignAutomationStatus from "./CampaignAutomationStatus";
import CampaignTemplateInfo from "./table/CampaignTemplateInfo";
import CampaignProductInfo from "./table/CampaignProductInfo";
import CampaignDateRange from "./table/CampaignDateRange";
import CampaignActions from "./table/CampaignActions";
import CampaignEmptyState from "./table/CampaignEmptyState";

interface CampaignsTableProps {
  campaigns: Campaign[];
  openEditModal: (campaign: LegacyCampaign) => void;
  openDeleteDialog: (campaign: Campaign) => void;
  openPublishDialog: (campaign: Campaign) => void;
  openResultsSheet: (campaign: LegacyCampaign) => void;
  openViewModal: (campaign: Campaign) => void;
  onDuplicate: (campaign: Campaign) => void;
  onFinalize: (campaign: Campaign) => void;
  onReactivate?: (campaign: Campaign) => void;
  status: "draft" | "active" | "scheduled" | "completed";
}

const CampaignsTable = ({
  campaigns,
  openEditModal,
  openDeleteDialog,
  openPublishDialog,
  openResultsSheet,
  openViewModal,
  onDuplicate,
  onFinalize,
  onReactivate,
  status
}: CampaignsTableProps) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50/50">
            <TableHead className="font-semibold">Nome da Campanha</TableHead>
            <TableHead className="font-semibold">Tipo & Template</TableHead>
            <TableHead className="font-semibold">Produto</TableHead>
            <TableHead className="font-semibold">Período</TableHead>
            <TableHead className="font-semibold">Status</TableHead>
            <TableHead className="text-right font-semibold">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {campaigns.length > 0 ? (
            campaigns.map((campaign) => (
              <TableRow key={campaign.id} className="hover:bg-gray-50/50">
                <TableCell className="font-medium text-gray-900">
                  {campaign.name}
                </TableCell>
                <TableCell>
                  <CampaignTemplateInfo campaign={campaign} />
                </TableCell>
                <TableCell>
                  <CampaignProductInfo campaign={campaign} />
                </TableCell>
                <TableCell>
                  <CampaignDateRange 
                    startDate={campaign.start_date} 
                    endDate={campaign.end_date} 
                  />
                </TableCell>
                <TableCell>
                  <CampaignAutomationStatus 
                    status={campaign.status as "draft" | "scheduled" | "active" | "completed"}
                    startDate={campaign.start_date}
                    endDate={campaign.end_date}
                  />
                </TableCell>
                <TableCell className="text-right">
                  <CampaignActions
                    campaign={campaign}
                    status={status}
                    openEditModal={openEditModal}
                    openDeleteDialog={openDeleteDialog}
                    openPublishDialog={openPublishDialog}
                    openResultsSheet={openResultsSheet}
                    openViewModal={openViewModal}
                    onDuplicate={onDuplicate}
                    onFinalize={onFinalize}
                    onReactivate={onReactivate}
                  />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <CampaignEmptyState status={status} />
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default CampaignsTable;
